module.exports = __webpack_public_path__ + "fonts/674b990cde281fc90e6cff6a9cc83886.svg";